import { PropsWithChildren } from 'react';
import TermsOfUseModal from '~/containers/terms-of-use-modal';
import AppConfig from '~/utils/appconfig';

/**
 * A React component that conditionally wraps its children with a `TermsOfUseModal`
 * based on the application's demo mode configuration.
 */
export default function DemoRoute({ children }: PropsWithChildren) {
    // If not in demo mode, render children directly
    if (!AppConfig.isDemo) {
        return children;
    }

    // otherwise ensure user has agreed to terms of use
    return <TermsOfUseModal>{children}</TermsOfUseModal>;
}
